import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { UIUtils } from "../../../services/uiutils.service";
import { DTU } from "../../../services/dtu.service";
import {
  DxChartComponent,
  DxChartModule,
  DxDataGridComponent,
  DxFunnelModule,
  DxPieChartComponent,
  DxPieChartModule,
} from "devextreme-angular";
import { DashboardsFetchRequest } from "../../../classes/domain/entities/website/dashboard/dashboardfetchrequest";
import { PayloadPacketFacade } from "../../../classes/infrastructure/payloadpacket/payloadpacketfacade";
import { ServerCommunicatorService } from "../../../services/server-communicator.service";
import { TransportData } from "../../../classes/infrastructure/transportdata";
import { Dashboards } from "../../../classes/domain/entities/website/dashboard/dashboard";
import { SharedModule } from "primeng/api";
import { DxiLegendModule } from "devextreme-angular/ui/nested";
import { DevextremesharedmoduleModule } from "../../../shared/Module/devextremeshared/devextremeshared.module";
import { FinancialYear } from "../../../classes/domain/entities/website/financialyear/financialyearmaster";
import {
  AnemiaMuktaBharatTypes,
  ContraceptivePillsTypes,
  DomainEnums,
  IncentiveRoles,
  IncentiveTypes,
  ReportFilterTypes,
  Roles,
  StateIncentiveTypes,
} from "../../../classes/infrastructure/enums";
import { Router } from "@angular/router";
import { AppStateManageService } from "../../../services/app-state-manage.service";
import { ScreenSizeService } from "../../../services/screensize.service";
import { Utils } from "../../../services/utils.service";
import { FinancialYearUtilsService } from "../../../services/current-financial-year.service";
import { SidebarMenuStateService } from "../../../services/sidebarmenustateservice";
import { NavItem_Entity_Authority } from "../../../shared/components/side-navigation-menu/side-navigation-menu.component";
import { DashboardHierarchyFilterService } from "../../../services/dashboardfilterstate.service";
import { DashboardFilterStateStorageService } from "../../../services/dashboard-filter-state-storage.service";
import { LanguageService } from "../../../services/language.service";
import { TranslateService } from "@ngx-translate/core";

interface MonthlyIncentiveTrendSummary {
  Month: string;
  Incentive: number;
}
interface DistributedFamily {
  Stock: string;
  Incentive: number;
}

// ✅ Interfaces
export interface PHCDetailsSummaryItems {
  PHCName: string;
  UniqueAshaTrained: number;
  PerformanceCoveragePercent: number;
  [Item: string]: string | number;
}

export interface IncentiveBuckets {
  Name: string;
  Value: number;
  [Item: string]: string | number;
}

export interface TrainingCompletionChartItem {
  p: {
    Name: string;
  };
}

export interface performancephcitem {
  p: {
    Name: string;
  };
}

export interface monthlyincentiveearnedbyasha {
  p: {
    Name: string;
  };
}

export interface DistributedStockSeries {
  p: {
    Name: string;
    DisplayName: string;
  };
}

export interface DistributedStock {
  DistributedSanitoryPadStock: number;
  DistributedContraceptiveCondomStock: number;
  DistributedContraceptiveMalaNStock: number;
  DistributedContraceptiveECPillsStock: number;
  DistributedContraceptiveChhayaStock: number;
}

interface StockBuckets {
  ContraceptivePillType: number;
  ContraceptivePillTypeName: string;
  OpeningStock: number;
  ReceivedStock: number;
  DistributedStock: number;
  RemainingStock: number;
}

interface IFATablet {
  Remaining: number;
  Consume: number;
  Received: number;
}

export class DistributedStockChartData {
  Name: string = "";
  SanitaryPads: number = 0;
  Condoms: number = 0;
  MalaN: number = 0;
  ECPills: number = 0;
  Chhaya: number = 0;
}
export class AnemiaMuktaBharatTypesResponse {
  AnemiaMuktaBharatType: number = 0;
  AnemiaMuktaBharatTypeName: string = "";
  OpeningStock: number = 0;
  ReceivedStock: number = 0;
  DistributedStock: number = 0;
  RemainingStock: number = 0;
}

@Component({
  selector: "app-dashboard",
  standalone: true,
  imports: [
    SharedModule,
    DevextremesharedmoduleModule,
    DxPieChartModule,
    DxiLegendModule,
    DxChartModule,
    DxFunnelModule,
  ],
  templateUrl: "./dashboard.component.html",
  styleUrl: "./dashboard.component.scss",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardComponent {
  pageSize: number = 0;
  loading = true;
  data: any[] = [];
  columns: any[] = [];
  YearsList: FinancialYear[] = [];
  isApril: boolean = false;
  FilterList = DomainEnums.ReportFilterTypesListLang(
    true,
    "REPORT_PLACEHOLDERS.Select",
  );
  MonthList = DomainEnums.MonthListLang(
    true,
    "REPORT_PLACEHOLDERS.SelectMonth",
  );
  QuarterList = DomainEnums.QuarterTypesListLang(
    true,
    "REPORT_PLACEHOLDERS.SelectQuarter",
  );
  HalfYearList = DomainEnums.HalfYearListLang(
    true,
    "REPORT_PLACEHOLDERS.SelectHalfYear",
  );

  FromDate: string = "";
  ToDate: string = "";
  IsShowMonth: boolean = false;
  IsShowQuarter: boolean = false;
  IsShowHalfYear: boolean = false;
  IsShowDates: boolean = false;
  isLoading: boolean = false;

  CurrentFinancialYear: string = "";
  financialYearStart!: Date;
  financialYearEnd!: Date;

  Title: string = "";
  SubTitle: string = "";
  BaseTitle: string = "प्रपत्र -१";
  BaseSubTitle: string = "Asha Primary Information Sheet";
  HalfYearTitleList = [
    { Ref: 100, Name: "Apr - Sept" },
    { Ref: 200, Name: "Oct - Mar" },
  ];

  LoginPostRef: number = 0;
  LoginUserRef: number = 0;
  AFEmployeeRecordRefs: number[] = [];
  AshaEmployeeRecordRef: number[] = [];
  isFilterActive = false;
  popupPosition: any;
  autoHeight: string | number = "auto";
  IsNewEntity: boolean = true;
  RoleList = DomainEnums.IncentiveRolesList(false);
  IncentiveRoles = IncentiveRoles;
  Roles = Roles

  AFEmployeeRecordRef: number = 0;
  AshaEmployeeRecordRefs: number = 0;
  LoginEmployeeRole: number = 0;

  EntityType: string = "Asha_Profile_Data";
  EntityAuthority: NavItem_Entity_Authority | undefined = undefined;

  IncentiveRole: number = 0;
  Sanctioned: number = 0;
  TotalGiven: number = 0;
  Pending: number = 0;
  // below variables for chart

  ReportFilterType: number = 0;
  showFilters: boolean = true;

  intervalId: any;

  MonthlyIncentiveTrend: MonthlyIncentiveTrendSummary[] = [];
  DistributedFamily: DistributedFamily[] = [];

  counterTimers: { [id: string]: any } = {};

  previousData: any = null; //  holds last API snapshot

  TrainingCompletion: any[] = [];
  TrainingCompletionList: TrainingCompletionChartItem[] = [];

  performancephcdata: any[] = [];
  performancephclist: performancephcitem[] = [];

  monthlyincentiveofashadata: any[] = [];
  monthlyincentiveofashaList: monthlyincentiveearnedbyasha[] = [];

  AvailableStock: any[] = [];
  IFATablet: any[] = [];
  IFASyrup: any[] = [];
  familyStatusData: any[] = [];
  PNCRegisterData: any[] = [];

  DistributedStockData: DistributedStockChartData[] = [];
  DistributedStockList: DistributedStockSeries[] = [];
  AnemiaMuktaBharatTypesList: AnemiaMuktaBharatTypesResponse[] = [];
  StockBuckets: StockBuckets[] = [];

  AnemiaMuktaBharatTypesEnum = AnemiaMuktaBharatTypes;
  AnemiaMuktaBharatTypesEnumList = DomainEnums.AnemiaMuktaBharatTypeList(
    true,
    "select",
  );
  PHCDetails: any[] = [];

  today = new Date(); // To date Date restriction
  @ViewChild("dataGrid", { static: false }) dataGrid!: DxDataGridComponent;
  constructor(
    private uiUtils: UIUtils,
    private router: Router,
    private appStateManage: AppStateManageService,
    private screenSizeService: ScreenSizeService,
    private utils: Utils,
    private ServerCommunicatorService: ServerCommunicatorService,
    private dtu: DTU,
    private CustomDate: FinancialYearUtilsService,
    public DashboardFilterService: DashboardHierarchyFilterService,
    private sidebarMenuState: SidebarMenuStateService,
    public filterStorage: DashboardFilterStateStorageService,
    public langService: LanguageService,
    private translate: TranslateService,
  ) {}

  @ViewChildren(DxPieChartComponent) pieCharts!: QueryList<DxPieChartComponent>;
  @ViewChild("MonthlyIncentiveTrendChart", { static: false })
  lineChart!: DxChartComponent;
  @ViewChild("DistributedFamilyChart", { static: false })
  distributedFamilyChart!: DxChartComponent;
  @ViewChild("TrainingCompletionChart", { static: false })
  distributedStockChart!: DxChartComponent;
  TrainingCompletionChart!: DxChartComponent;

  async ngOnInit() {
    this.sidebarMenuState.role$.subscribe((role) => {
      this.LoginEmployeeRole = role ?? 0;
    });
    this.LoginUserRef = this.appStateManage.getLoginUserRef();
    this.LoginPostRef = this.appStateManage.getPostRef();
    this.LoginEmployeeRole = this.appStateManage.getRole();

    this.FilterList = DomainEnums.ReportFilterTypesListLang(false).filter(
      (r) =>
        r.Ref !== ReportFilterTypes.None && r.Name.toLowerCase() !== "select",
    );
      // On language change, refresh dropdown lists so DevExtreme re-renders translated text
      this.translate.onLangChange.subscribe(async () => {
      // force dropdown list + selected text to refresh
        this.FilterList = [...this.FilterList];
        this.MonthList = [...this.MonthList];
        this.QuarterList = [...this.QuarterList];
        this.HalfYearList = [...this.HalfYearList];
      });
    const stored = this.appStateManage.StorageKey.getItem(
      "FinancialYearResponses",
    );
    const financialYearResponses = stored ? JSON.parse(stored) : [];

    if (financialYearResponses.length) {
      this.DashboardFilterService.FinancialYearRef =
        financialYearResponses[0].financial_year_id;
      this.CurrentFinancialYear = financialYearResponses[0].short_name;
      this.isApril = financialYearResponses.length > 1;
    }

    this.loading = false;
    this.pageSize = this.screenSizeService.getPageSize("withDropdown", 3);

    this.FilterList = DomainEnums.ReportFilterTypesListLang(false).filter(
      (r) => r.Ref !== ReportFilterTypes.Custom,
    );

    await this.FinancialYear(this.CurrentFinancialYear);
    await this.FormulateFinancialYearList();

    // ✅ Check stored state FIRST
    const existingStoredState = this.filterStorage.getFilterState();

    // ✅ If no ReportFilterType stored yet → set Yearly as default AND save it
    if (!existingStoredState?.ReportFilterType) {
      this.DashboardFilterService.ReportFilterType = ReportFilterTypes.Yearly;

      // ✅ Save default to storage so it persists
      this.filterStorage.setFilterState({
        ...existingStoredState,
        FinancialYearRef: this.DashboardFilterService.FinancialYearRef,
        ReportFilterType: ReportFilterTypes.Yearly,
      });
    }
    if (existingStoredState.state_ids.length == 0) {
      return; // old code was here
      await this.DashboardFilterService.LoadFilterDataUPTOStateLevel();
    }

    // Default Role = ASHA (only if not stored)
    if (
      !this.DashboardFilterService.IncentiveRole ||
      this.DashboardFilterService.IncentiveRole === 0
    ) {
      this.DashboardFilterService.IncentiveRole = IncentiveRoles.Asha;
    }

    await this.applyDashaboardStateOnFilterDropdown();
    // 👉 set static data after role is known
    this.setPNCStaticData();
    this.intervalId = setInterval(() => {
      this.FormulateDashboardList();
    }, 60000);
  }

  selectedArea: "rural" | "urban" = "rural"; // ✅ default rural
  isUrbanNoData: boolean = false;
  onAreaChange(area: "rural" | "urban") {
    if (this.selectedArea === area) return;

    this.selectedArea = area;

    if (area === "urban") {
      this.isUrbanNoData = true;
      // ✅ Clear UI state
      this.resetDashboardData();
      return;
    }
    this.isUrbanNoData = false;
    // ✅ Reset comparison so animation runs
    this.previousData = null;

    this.FormulateDashboardList();
  }

  resetDashboardData() {
    // Cards
    this.Sanctioned = 0;
    this.TotalGiven = 0;
    this.Pending = 0;

    // Charts
    this.familyStatusData = [];
    this.PNCRegisterData = [];
    this.TrainingCompletion = [];
    this.performancephcdata = [];
    this.monthlyincentiveofashadata = [];
    this.DistributedFamily = [];
    this.AvailableStock = [];
    this.IFATablet = [];
    this.IFASyrup = [];

    // Stop animations
    Object.values(this.counterTimers).forEach(clearInterval);
    this.counterTimers = {};
  }

  applyDashaboardStateOnFilterDropdown = async () => {
    const savedState = this.filterStorage.getFilterState();

    const hasStoredFilters =
      savedState.state_ids?.length > 0 ||
      savedState.district_ids?.length > 0 ||
      savedState.block_ids?.length > 0 ||
      savedState.phc_ids?.length > 0 ||
      savedState.zone_ids?.length > 0 ||
      savedState.bcm_post_ids?.length > 0 ||
      savedState.af_ids?.length > 0 ||
      savedState.sc_ids?.length > 0 ||
      savedState.village_ids?.length > 0 ||
      savedState.asha_ids?.length > 0;

    // ✅ Use stored value, fallback to Yearly only if nothing stored
    const reportFilterType =
      savedState?.ReportFilterType ?? ReportFilterTypes.Yearly;
    this.DashboardFilterService.ReportFilterType = reportFilterType;
    this.applyFilterVisibility(reportFilterType);

    if (savedState?.Month) this.DashboardFilterService.Month = savedState.Month;
    if (savedState?.QuarterlyYearType)
      this.DashboardFilterService.QuarterlyYearType =
        savedState.QuarterlyYearType;
    if (savedState?.HalfYearType)
      this.DashboardFilterService.HalfYearType = savedState.HalfYearType;
    if (savedState?.IncentiveRole)
      this.DashboardFilterService.IncentiveRole = savedState.IncentiveRole;

    if (hasStoredFilters) {
      return; // old code was here
      await this.DashboardFilterService.LoadFilterDataUPTOStateLevel();
      await this.DashboardFilterService.restoreFromStoredState({
        ...savedState,
        asha_ids: savedState.asha_ids ?? [],
      });
    }

    await this.FormulateDashboardList();
  };

  applyFilterVisibility(filterType: number) {
    this.IsShowMonth = filterType === ReportFilterTypes.Monthly;
    this.IsShowQuarter = filterType === ReportFilterTypes.Quarterly;
    this.IsShowHalfYear = filterType === ReportFilterTypes.HalfYearly;
    this.IsShowDates = filterType === ReportFilterTypes.Custom;
  }

  onPieSliceClick(e: any) {
    const clickedItem = e.target.data;
    // ✅ Set BOTH storage AND service
    this.DashboardFilterService.AnemiaMuktaBharatType = 100;

    this.filterStorage.setFilterState({
      AnemiaMuktaBharatType: 100,
      AnemiaMuktaBharatTabletclickedItem: clickedItem,
    });

    this.router.navigate(["/Dashboard_Anemia_Mukta_Bharat"]);

    // Navigate based on slice name or value
    // if (clickedItem.Name === 'Available') {
    //   this.router.navigate(['/available-stock']);
    // }
    // else if (clickedItem.Name === 'OutOfStock') {
    //   this.router.navigate(['/out-of-stock']);
    // }
    // else {
    //   this.router.navigate(['/stock-details', clickedItem.Name]);
    // }
  }

  getPendingFamilies = async () => {
    // await this.router.navigate(["Total_Asha_Trained"]);
  };

  getApprovedFamilies = async () => {
    // await this.router.navigate(["Dashboard_Total_Asha_Registered"]);
  };

  onIFASyrupPieSliceClick(e: any) {
    const clickedItem = e.target?.data;

    if (!clickedItem) return;
    this.DashboardFilterService.AnemiaMuktaBharatType = 200;
    this.filterStorage.setFilterState({
      AnemiaMuktaBharatType: 200,
      AnemiaMuktaBharatTabletclickedItem: clickedItem,
    });

    this.router.navigate(["/Dashboard_Anemia_Mukta_Bharat"]);
  }

  // private contraceptiveTypeMap: { [key: string]: number } = {
  //   "Sanitary pad": 0,
  //   "Condom": 100,
  //   "Mala-N": 200,
  //   "EC-Pills": 300,
  //   "Chhaya": 400
  // };

  // onFamilyPlanningStockPieSliceClick(e: any) {
  //   const clickedItem = e.target?.data;

  //   if (!clickedItem || !clickedItem.Name) return;

  //   const typeNumber = this.contraceptiveTypeMap[clickedItem.Name];

  //   this.filterStorage.setFilterState({
  //     ContraceptivePillType: typeNumber,
  //     ContraceptivePillTypeName: clickedItem.Name,  // ← 'Condom'
  //   });

  //   this.router.navigate(['/Dashboard_Contraceptive_pills']);
  // }

  SANITARY_PAD_VALUE: number = 0;
  onFamilyPlanningStockPieSliceClick(e: any) {
    const clickedItem = e.target?.data;

    if (!clickedItem || !clickedItem.Name) return;

    const pillTypeList = DomainEnums.ContraceptivePillsTypeList();

    const normalize = (str: string) => str.replace(/[-\s]/g, "").toLowerCase();

    const matched = pillTypeList.find(
      (p) => normalize(p.Name) === normalize(clickedItem.Name),
    );

    const pillType = matched ? matched.Ref : 0;
    const pillName = matched ? matched.Name : clickedItem.Name;

    this.filterStorage.setFilterState({
      ContraceptivePillType: pillType,
      ContraceptivePillTypeName: pillName,
    });
    this.router.navigate(["/Dashboard_Contraceptive_pills"]);
  }

  onBarChartClick(e: any) {
    const clickedItem = e.target?.data;

    if (!clickedItem || !clickedItem.Stock) return;

    const pillTypeList = DomainEnums.ContraceptivePillsTypeList();
    const matched = pillTypeList.find((p) => p.Name === clickedItem.Stock);

    // If not found in enum list → it's Sanitary Pad (value 0)
    const pillType = matched ? matched.Ref : 0;
    const pillName = matched ? matched.Name : "Sanitary Pad";

    this.filterStorage.setFilterState({
      ContraceptivePillType: pillType,
      ContraceptivePillTypeName: pillName,
    });

    this.router.navigate(["/Dashboard_Contraceptive_pills"]);
  }

  onBarClick(e: any) {
    const clickedBar = e.target.data;

    let incentiveType = this.GetAshaIncentiveType(clickedBar.Name);
    // debugger

    this.filterStorage.setFilterState({
      IncentiveType: incentiveType,
    });
    this.router.navigate(["/Dashboard_Asha_Incentive"]);

    // clickedBar.Name = X-axis label
    // clickedBar.Value = bar value

    // if (clickedBar.Name === '0-500') {
    //   this.router.navigate(['/incentive-low']);
    // }
    // else if (clickedBar.Name === '500-1000') {
    //   this.router.navigate(['/incentive-medium']);
    // }
    // else {
    //   this.router.navigate(['/incentive-details', clickedBar.Name]);
    // }
  }

  onAshaPerformanceChanged(incentiveName: string) {
    // debugger

    let incentiveType = this.GetAshaIncentiveType(incentiveName);
    // debugger

    // ✅ Set BOTH storage AND service
    this.DashboardFilterService.IncentiveType = incentiveType;

    this.filterStorage.setFilterState({
      IncentiveType: incentiveType,
    });
    this.router.navigate(["/Dashboard_Asha_Incentive"]);
  }

  GetAshaIncentiveType = (incentiveName: string): number => {
    // debugger
    switch (incentiveName) {
      case "Zero Incentive":
        return IncentiveTypes.ZeroIncentive;
      case "Below ₹13,000":
        return IncentiveTypes.IncentiveBelow13000;
      case "₹13,001-15,000":
        return IncentiveTypes.Incentive13001To15000;
      case "₹15,001-20,000":
        return IncentiveTypes.Incentive15001To20000;
      case "Above ₹20,000":
        return IncentiveTypes.IncentiveAbove20000;
      case "LowPerformance":
        return IncentiveTypes.IncentiveBelow15000;
      case "TopPerformance":
        return IncentiveTypes.IncentiveAbove15000;
      case "IncentiveAnalysis":
        return IncentiveTypes.IncentiveAnalysis;
      case "ZeroPerformance":
        return IncentiveTypes.ZeroIncentive;
      default:
        return 0;
    }
  };
  // dropdown filter code start

  FinancialYear = async (FinancialYear: string) => {
    //   reusable call for Date selcetion in that Current Financial Year
    const range = this.CustomDate.getFinancialYearRange(FinancialYear);
    if (range) {
      this.financialYearStart = range.start;
      this.financialYearEnd = range.end;
    }
  };

  // Update toggleFilterPopup method
  async toggleFilterPopup() {
    return; // No need to toggle if filters are not implemented yet
    if (this.isFilterActive) {
      this.isFilterActive = false;
    } else {
      this.isFilterActive = true;
    }
    // ✅ Ensure service has the correct FinancialYearRef before loading
    // await this.DashboardFilterService.LoadFilterDataUPTOStateLevel();
    // this.StateRef = this.DashboardFilterService.StateRefs;
  }

  // Update applyFilters method
  applyFilters = async () => {
    // debugger
    // Save the applied filters

    this.isFilterActive = false;
    this.filterStorage.setFilterState({
      FinancialYearRef: this.DashboardFilterService.FinancialYearRef,
      ReportFilterType: this.DashboardFilterService.ReportFilterType,
      Month: this.DashboardFilterService.Month,
      QuarterlyYearType: this.DashboardFilterService.QuarterlyYearType,
      HalfYearType: this.DashboardFilterService.HalfYearType,

      // ✅ Always read from service, single source of truth
      state_ids: this.DashboardFilterService.state_ids,
      zone_ids: this.DashboardFilterService.zone_ids,
      district_ids: this.DashboardFilterService.district_ids,
      block_ids: this.DashboardFilterService.block_ids,
      bcm_post_ids: this.DashboardFilterService.bcm_post_ids,
      phc_ids: this.DashboardFilterService.phc_ids,
      af_ids: this.DashboardFilterService.af_ids,
      sc_ids: this.DashboardFilterService.sc_ids,
      village_ids: this.DashboardFilterService.village_ids,
      asha_ids: this.DashboardFilterService.asha_ids,
    });
    //   'ReportFilterType', this.DashboardFilterService.ReportFilterType,
    //   'Month', this.DashboardFilterService.Month,
    //   'QuarterlyYearType', this.DashboardFilterService.QuarterlyYearType,
    //   'HalfYearType', this.DashboardFilterService.HalfYearType,
    // )
    await this.FormulateDashboardList();
  };

  getAshaTrained = async () => {
    await this.router.navigate(["Total_Asha_Trained"]);
  };

  getAshaRegistered = async () => {
    await this.router.navigate(["Dashboard_Total_Asha_Registered"]);
  };

  getTopFiveAshaIncentive = async () => {
    let incentiveType = IncentiveTypes.TopFiveIncentive;
    let title = "Top 5 Asha Performed";
    this.DashboardFilterService.IncentiveType = incentiveType;

    this.filterStorage.setFilterState({
      IncentiveType: incentiveType,
      Title: title,
    });
    await this.router.navigate(["Dashboard_Top_Five_Asha_Incentive"]);
  };

  async clearFilters() {
    // ✅ Clear BOTH service and local state
    // this.DashboardFilterService.StateRefs = [];
    // this.DashboardFilterService.ZoneRefs = [];
    // this.DashboardFilterService.DistrictRefs = [];
    this.DashboardFilterService.block_ids = [];
    this.DashboardFilterService.bcm_post_ids = [];
    this.DashboardFilterService.phc_ids = [];
    this.DashboardFilterService.af_ids = [];
    this.DashboardFilterService.sc_ids = [];
    this.DashboardFilterService.village_ids = [];
    this.DashboardFilterService.asha_ids = [];
    //    this.IsStateDisabled = false;
    // this.IsZoneDisabled = false;
    // this.IsDistrictDisabled = false;
    // this.DashboardFilterService.IsBlockDisabled = false;
    // this.DashboardFilterService.IsBCMPostDisabled = false;
    // this.DashboardFilterService.IsPHCDisabled = false;
    // this.DashboardFilterService.IsAFPostDisabled = false;
    // this.DashboardFilterService.IsSCDisabled = false;
    // this.DashboardFilterService.IsVillageDisabled = false;
    // this.DashboardFilterService.IsAshaDisabled = false;
    this.isFilterActive = false;
  }

  FormulateFinancialYearList = async () => {
    let lst = await FinancialYear.FetchEntireList(
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );

    this.YearsList = lst;
  };

  OnFilterChange = async (FilterRef: number) => {
    if (FilterRef == 0) return;

    this.DashboardFilterService.ReportFilterType = FilterRef;
    this.columns = [];
    this.data = [];
    this.FromDate = "";
    this.ToDate = "";

    // ✅ Reset time-period values when filter type changes
    this.DashboardFilterService.Month = 0;
    this.DashboardFilterService.QuarterlyYearType = 0;
    this.DashboardFilterService.HalfYearType = 0;

    // ✅ Use centralized helper (no need for if/else block below)
    this.applyFilterVisibility(FilterRef);

    // ✅ Save to storage (single call)
    this.filterStorage.setFilterState({
      ReportFilterType: FilterRef,
    });

    // ✅ Only call API for Yearly (others wait for sub-filter selection)
    if (FilterRef === ReportFilterTypes.Yearly) {
      await this.FormulateDashboardList();
    }
  };

  OnDateChange = (FromDate: string, ToDate: string) => {
    this.columns = [];
    this.data = [];

    if (FromDate === "" || ToDate === "") {
      return;
    }

    this.DashboardFilterService.FromDate = FromDate;
    this.DashboardFilterService.ToDate = ToDate;
    // this.GetTotalAshaTrained();
  };

  async onYearChanged(e: any) {
    const newValue = e.value;

    if (!newValue || newValue === 0) {
      e.component.option("value");
      return;
    }

    this.DashboardFilterService.FinancialYearRef = newValue;
    this.filterStorage.setFilterState({
      FinancialYearRef: this.DashboardFilterService.FinancialYearRef,
    });
    //  For financial Year //
    const selectedYear = this.YearsList.find(
      (y) => y.p.id === newValue || y.p.id === newValue,
    );

    if (!selectedYear) {
      return;
    }

    this.CurrentFinancialYear = selectedYear.p.short_name;
    // Code End //

    if (
      (this.DashboardFilterService.FinancialYearRef && e.previousValue == 0) ||
      e.previousValue == null
    ) {
      return;
    }
    this.columns = [];
    this.data = [];
    await this.FormulateDashboardList();
  }

  onCellPrepared(e: any) {
    if (e.rowType === "data" && e.column.caption === "Sr. No") {
      const pageIndex = e.component.pageIndex();
      const pageSize = e.component.pageSize();
      e.cellElement.innerText = pageIndex * pageSize + e.rowIndex + 1;
    }
  }

  // ✅ function to safely reset chart zoom/pan range
  resetChartZoom(chartRef: DxChartComponent | null) {
    if (chartRef && chartRef.instance) {
      try {
        const argumentAxis = chartRef.instance.getArgumentAxis();
        if (argumentAxis) {
          // 🔄 Type-safe way to reset zoom/pan
          (argumentAxis as any).visualRange(null);
        }
        setTimeout(() => chartRef.instance.render(), 30);
      } catch (error) {
        console.warn("Chart reset failed:", error);
      }
    }
  }

  ngAfterViewInit() {
    // Repaint all charts after view init
    setTimeout(() => {
      this.pieCharts.forEach((chart) => {
        chart.instance.render(); //  use render() instead of repaint()
      });
    }, 50);
  }

  // Api call every 1 minute //
  ngOnDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  // Compare helper
  private isEqual(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  // family folder pie chart function //
  isFamilyStatusEmpty(): boolean {
    return !this.familyStatusData || this.familyStatusData.length === 0;
  }

  //  Normal Dashboard Api Call
  FormulateDashboardList = async () => {
    // return;
    // debugger
    let req = new DashboardsFetchRequest();
    let tdRequest = req.FormulateTransportData();

    const loginUserRef = this.appStateManage.getLoginUserRef();
    const loginPostRef = this.appStateManage.getPostRef();
    const loginRole = this.appStateManage.getRole();

    switch (loginRole) {
      // case Roles.DCM:
      //   req.dcm_post_ids.push(loginPostRef);
      //   req.dcm_employee_record_ids.push(loginUserRef);
      //   break;

      // case Roles.BCM:
      //   req.bcm_post_ids.push(loginPostRef);
      //   req.bcm_employee_record_ids.push(loginUserRef);
      //   break;

      // case Roles.AF:
      //   req.af_post_ids.push(loginPostRef);
      //   req.af_employee_record_ids.push(loginUserRef);
      //   break;

      // case Roles.Asha:
      //   req.asha_post_ids.push(loginPostRef);
      //   req.asha_employee_record_ids.push(loginUserRef);
      //   break;

      // case Roles.DHO:
      //   req.district_ids.push(this.appStateManage.getDistrictRef());
      //   break;

      // case Roles.THO:
      //   req.block_ids.push(this.appStateManage.getBlockRef());
      //   break;

      // case Roles.MO:
      //   req.phc_ids.push(this.appStateManage.getPHCRef());
      //   break;
    }

    if (this.DashboardFilterService.IncentiveRole) {
      req.incentive_role = this.DashboardFilterService.IncentiveRole;
    }
    if (this.DashboardFilterService.FinancialYearRef) {
      req.financial_year_ids.push(this.DashboardFilterService.FinancialYearRef);
    }
    if (this.DashboardFilterService.ReportFilterType) {
      req.report_filter_type = this.DashboardFilterService.ReportFilterType;
    }
    if (this.DashboardFilterService.Month) {
      req.month = this.DashboardFilterService.Month;
    }
    if (this.DashboardFilterService.ReportFilterType) {
      req.report_filter_type = this.DashboardFilterService.ReportFilterType;
    }
    if (this.DashboardFilterService.QuarterlyYearType) {
      req.quarterly_year_type = this.DashboardFilterService.QuarterlyYearType;
    }
    if (this.DashboardFilterService.HalfYearType) {
      req.half_year_type = this.DashboardFilterService.HalfYearType;
    }

    if (this.DashboardFilterService.state_ids.length > 0) {
      req.state_ids = this.DashboardFilterService.state_ids;
    }
    if (this.DashboardFilterService.zone_ids.length > 0) {
      req.zone_ids = this.DashboardFilterService.zone_ids;
    }

    if (this.DashboardFilterService.district_ids.length > 0) {
      req.district_ids = this.DashboardFilterService.district_ids;
    }

    if (this.DashboardFilterService.block_ids.length > 0) {
      req.block_ids = this.DashboardFilterService.block_ids;
    }

    if (this.DashboardFilterService.phc_ids.length > 0) {
      req.phc_ids = this.DashboardFilterService.phc_ids;
    }

    if (this.DashboardFilterService.sc_ids.length > 0) {
      req.sc_ids = this.DashboardFilterService.sc_ids;
    }
    if (this.DashboardFilterService.bcm_post_ids.length > 0) {
      req.bcm_post_ids = this.DashboardFilterService.bcm_post_ids;
    }

    if (this.DashboardFilterService.village_ids.length > 0) {
      req.village_ids = this.DashboardFilterService.village_ids;
    }
    if (this.DashboardFilterService.asha_ids.length > 0) {
      req.asha_employee_record_ids = this.DashboardFilterService.asha_ids;
    }

    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(
      req.FormulateTransportData(),
    );
    let tr =
      await ServerCommunicatorService.GetInstance().sendHttpRequestWithoutLoader(
        pktRequest,
      );

    if (!tr.Successful) {
      await this.uiUtils.showInformationalMessage("Error", tr.Message);
      return;
    }

    const tdResponse = JSON.parse(tr.Tag) as TransportData;
    const res = Dashboards.FromTransportData(tdResponse);
    console.log('res :', res);
    if (!res || res.length === 0) return;

    const data = res[0];
    console.log("data dashboard :", data);

    // ✅ --- Cards Counter ✅ ---

    // family cards code --
 if (
      !this.previousData ||
      this.previousData.total_members_count !== data.total_members_count
    ) {
      this.animateCounter("totalmemberscount", data.total_members_count);
    }
    if (
      !this.previousData ||
      this.previousData.no_of_families !== data.no_of_families
    ) {
      this.animateCounter("nooffamilies", data.no_of_families);
    }
    if (
      !this.previousData ||
      this.previousData.no_of_members_above_thirty_years !==
        data.no_of_members_above_thirty_years
    ) {
      this.animateCounter(
        "noofmembersabovethirtyyears",
        data.no_of_members_above_thirty_years,
        1500,
      );
    }
    if (
      !this.previousData ||
      this.previousData.no_of_childern_below_five_years !==
        data.no_of_childern_below_five_years
    ) {
      this.animateCounter(
        "noofchildernbelowfiveyears",
        data.no_of_childern_below_five_years,
        1500,
      );
    }
    if (
      !this.previousData ||
      this.previousData.IncentiveAnalysis !== data.IncentiveAnalysis
    ) {
      this.animateCounter("IncentiveAnalysis", data.IncentiveAnalysis, 1500);
    }
    if (
      !this.previousData ||
      this.previousData.pending_families !== data.pending_families
    ) {
      this.animateCounter("pendingfamilies", data.pending_families, 1500);
    }
    // top 5 asha
    if (!this.previousData || this.previousData.TopFive !== data.TopFive) {
      this.animateCounter("TopFive", data.TopFive);
    }


    if (
      !this.previousData ||
      this.previousData.approved_families !== data.approved_families
    ) {
      this.animateCounter("approvedfamilies", data.approved_families, 1500);
    }
    // Zero Incentives
    if (
      !this.previousData ||
      this.previousData.ZeroIncentive !== data.ZeroIncentive
    ) {
      this.animateCounter("ZeroIncentive", data.ZeroIncentive);
    }
    if (
      !this.previousData ||
      this.previousData.Below_15000 !== data.Below_15000
    ) {
      this.animateCounter("LowPerformance", data.Below_15000, 1500);
    }
    if (
      !this.previousData ||
      this.previousData.Above_15000 !== data.Above_15000
    ) {
      this.animateCounter("TopPerformance", data.Above_15000, 1500);
    }
    if (
      !this.previousData ||
      this.previousData.IncentiveAnalysis !== data.IncentiveAnalysis
    ) {
      this.animateCounter("IncentiveAnalysis", data.IncentiveAnalysis, 1500);
    }
    if (
      !this.previousData ||
      this.previousData.total_asha_trained !== data.total_asha_trained
    ) {
      this.animateCounter("totalashatrained", data.total_asha_trained, 1500);
    }
    // top 5 asha
    if (!this.previousData || this.previousData.top_five !== data.top_five) {
      this.animateCounter("topfive", data.top_five);
    }

    if (
      !this.previousData ||
      this.previousData.total_asha_registered !== data.total_asha_registered
    ) {
      this.animateCounter(
        "totalasharegistered",
        data.total_asha_registered,
        1500,
      );
    }
    if (
      !this.previousData ||
      this.previousData.TotalIncentive !== data.TotalIncentive
    ) {
      this.animateCounter("Sanctioned", data.TotalIncentive, 1500, true);
    }
    if (
      !this.previousData ||
      this.previousData.TotalIncentiveTaken !== data.TotalIncentiveTaken
    ) {
      this.animateCounter("TotalGiven", data.TotalIncentiveTaken, 1500, true);
    }
    if (
      !this.previousData ||
      this.previousData.RemainingIncentive !== data.RemainingIncentive
    ) {
      this.animateCounter("Pending", data.RemainingIncentive, 1500, true);
    }

    // PNC Chart
    const newPNCData = [
      {
        Name: "High Risk",
          // this.langService.currentLang === "mr"
          //   ? "उच्च जोखीम माता"
          //   : "High Risk",
        Value: data.high_risk_register_maata ?? 0,
      },
      {
        Name: "Low Risk",
          // this.langService.currentLang === "mr" ? "कमी जोखीम माता" : "Low Risk",
      
        Value: data.normal_register_maata ?? 0,
      },
    ];

    if (
      !this.previousData ||
      !this.isEqual(this.previousData.PNCRegisterData, newPNCData)
    ) {
      this.PNCRegisterData = newPNCData;
    }

    this.PHCDetails = data.PHCDetails;

    // ✅ --- Bar Chart ✅  ---
    if (data.PHCDetails && Array.isArray(data.PHCDetails)) {
      const summary = data.PHCDetails as PHCDetailsSummaryItems[];
      const Items = Object.keys(summary[0] || {}).filter(
        (k) => k == "UniqueAshaTrained",
      );

      const newTrainingCompletion = summary.map((item) => {
        const entry: any = { PHCName: item.PHCName };
        Items.forEach((Data) => (entry[Data] = item[Data] ?? 0));
        return entry;
      });

      if (
        !this.previousData ||
        !this.isEqual(
          this.previousData.TrainingCompletion,
          newTrainingCompletion,
        )
      ) {
        this.TrainingCompletion = newTrainingCompletion;
        this.TrainingCompletionList = Items.map((name) => ({
          p: { Name: name },
        }));
        this.resetChartZoom(this.TrainingCompletionChart); // ✅ Reset here
      }
    }

    if (data.PHCDetails && Array.isArray(data.PHCDetails)) {
      const summary = data.PHCDetails as PHCDetailsSummaryItems[];
      const Items = Object.keys(summary[0] || {}).filter(
        (k) => k == "PerformanceCoveragePercent",
      );

      const newTrainingCompletion = summary.map((item) => {
        const entry: any = { PHCName: item.PHCName };
        Items.forEach((Data) => (entry[Data] = item[Data] ?? 0));
        return entry;
      });

      if (
        !this.previousData ||
        !this.isEqual(
          this.previousData.TrainingCompletion,
          newTrainingCompletion,
        )
      ) {
        this.performancephcdata = newTrainingCompletion;
        this.performancephclist = Items.map((name) => ({
          p: { Name: name },
        }));
        this.resetChartZoom(this.TrainingCompletionChart); // ✅ Reset here
      }
    }

    if (data.IncentiveBuckets && Array.isArray(data.IncentiveBuckets)) {
      const summary = data.IncentiveBuckets as {
        Name: string;
        Value: number;
      }[];

      // Map directly into chart-friendly format
      const newTrainingCompletion = summary.map((item) => ({
        Name: item.Name, // X-axis or series label
        Value: item.Value ?? 0, // Y-axis value
      }));

      if (
        !this.previousData ||
        !this.isEqual(
          this.previousData.monthlyincentiveearnedbyasha,
          newTrainingCompletion,
        )
      ) {
        // Assign to chart data
        this.monthlyincentiveofashadata = newTrainingCompletion;

        // If you need a series list (for dynamic series), create from Names
        this.monthlyincentiveofashaList = summary.map((item) => ({
          p: { Name: item.Name },
        }));

        this.resetChartZoom(this.TrainingCompletionChart); // ✅ Reset chart
      }
    }

    //family folder pie chart //
    // ✅ --- Family Status Pie Chart ---
    // const newFamilyStatusData = [
    //   {
    //     Name: this.langService.currentLang === 'mr' ? 'मंजूर कुटुंबे' : 'Approved Families',
    //     Value: data.ApprovedFamilies ?? 0
    //   },
    //   {
    //     Name: this.langService.currentLang === 'mr' ? 'प्रलंबित कुटुंबे' : 'Pending Families',
    //     Value: data.PendingFamilies ?? 0
    //   },
    //   {
    //     Name: this.langService.currentLang === 'mr' ? 'स्थानिक कुटुंबे' : 'Native Families',
    //     Value: data.NativeFamilies ?? 0
    //   },
    //   {
    //     Name: this.langService.currentLang === 'mr' ? 'स्थलांतरित कुटुंबे' : 'Migrated Families',
    //     Value: data.MigratedFamilies ?? 0
    //   }
    // ];

     const newFamilyStatusData = [
      {
        Name:'Approved Families',
        Value: data.approved_families ?? 0
      },
      {
        Name: 'Pending Families',
        Value: data.pending_families ?? 0
      },
      {
        Name: 'Return Of Request Families',
        Value: data.return_for_request_families ?? 0
      },
      {
        Name: 'Native Families',
        Value: data.native_families ?? 0
      },
      {
        Name: 'Migrated Families',
        Value: data.migrated_families ?? 0
      }
    ];

    // optional: remove zero values (recommended for clean UI)
    const filteredFamilyStatusData = newFamilyStatusData.filter(
      (x) => x.Value > 0,
    );

    if (
      !this.previousData ||
      !this.isEqual(
        this.previousData.familyStatusData,
        filteredFamilyStatusData,
      )
    ) {
      this.familyStatusData = filteredFamilyStatusData;
    }

    // ✅ --- Distributed Family Line Chart ---
    const newDistributedFamily = data.StockBuckets ?? [];

    if (
      !this.previousData ||
      !this.isEqual(
        this.previousData.DistributedStockData,
        newDistributedFamily,
      )
    ) {
      const typeMap: any = {
        [ContraceptivePillsTypes.None]: "Sanitary Pad",
        [ContraceptivePillsTypes.Condom]: "Condom",
        [ContraceptivePillsTypes.Mala_N]: "Mala-N",
        [ContraceptivePillsTypes.ECPills]: "EC-Pills",
        [ContraceptivePillsTypes.Chhaya]: "Chhaya",
      };

      this.DistributedFamily = newDistributedFamily.map((e: StockBuckets) => ({
        Stock: typeMap[e.ContraceptivePillType],
        Incentive: e.DistributedStock === 0 ? 1 : e.DistributedStock,
      }));

      this.distributedFamilyChart?.instance.render();
      this.resetChartZoom(this.distributedFamilyChart);
    }

    // // ✅ --- RFQ Line Chart  ✅  ---
    // const newIncentive = data.MonthlyIncentivesByYear ?? [];

    // if (
    //   !this.previousData ||
    //   !this.isEqual(this.previousData.MonthlyIncentiveTrend, newIncentive)
    // ) {
    //   // Define financial year month order (Apr → Mar)
    //   const financialMonths = [
    //     "Apr",
    //     "May",
    //     "Jun",
    //     "Jul",
    //     "Aug",
    //     "Sep",
    //     "Oct",
    //     "Nov",
    //     "Dec",
    //     "Jan",
    //     "Feb",
    //     "Mar",
    //   ];

    //   // Transform monthly data into an array suitable for chart
    //   this.MonthlyIncentiveTrend = newIncentive.length
    //     ? financialMonths.map((month) => ({
    //       Month: month, // X-axis
    //       Incentive: newIncentive[0][month] ?? 0, // Y-axis
    //     }))
    //     : financialMonths.map((month) => ({
    //       Month: month,
    //       Incentive: 0,
    //     }));

    //   this.lineChart?.instance.render();
    //   this.resetChartZoom(this.lineChart); // ✅ Reset zoom
    // }

    // // ✅ --- RFQ Line Chart  ✅  ---
    // const newDistributedFamily = data.DistributedFamily ?? [];

    // if (
    //   !this.previousData ||
    //   !this.isEqual(this.previousData.newDistributedFamily, newDistributedFamily)
    // ) {
    //   // Define distributed Family order
    //   const distributedFamily = [
    //     "Sanitory Pad",
    //     "Condom",
    //     "Mala-N",
    //     "EC-Pills",
    //     "Chhaya",
    //   ];

    //   // Transform monthly data into an array suitable for chart
    //   this.DistributedFamily = newDistributedFamily.length
    //     ? distributedFamily.map((stock) => ({
    //       Stock: stock, // X-axis
    //       Incentive: newDistributedFamily[0][stock] ?? 0, // Y-axis
    //     }))
    //     : distributedFamily.map((stock) => ({
    //       Stock: stock,
    //       Incentive: 0,
    //     }));

    //   this.lineChart?.instance.render();
    //   this.resetChartZoom(this.lineChart); // ✅ Reset zoom
    // }

    // ✅ Available Stock Pie Chart  ✅
    this.StockBuckets = data.StockBuckets;
    if (this.StockBuckets.length > 0) {
      const stockMap: any = {
        [ContraceptivePillsTypes.None]: { Name: "Sanitary Pad", Value: 0 },
        [ContraceptivePillsTypes.Condom]: { Name: "Condom", Value: 0 },
        [ContraceptivePillsTypes.Mala_N]: { Name: "Mala-N", Value: 0 },
        [ContraceptivePillsTypes.ECPills]: { Name: "EC-Pills", Value: 0 },
        [ContraceptivePillsTypes.Chhaya]: { Name: "Chhaya", Value: 0 },
      };

      this.StockBuckets.forEach((e) => {
        if (stockMap[e.ContraceptivePillType]) {
          stockMap[e.ContraceptivePillType].Value = e.RemainingStock;
        }
      });

      const newAvailableStock = Object.values(stockMap);

      if (
        !this.previousData ||
        !this.isEqual(this.previousData.AvailableStock, newAvailableStock)
      ) {
        this.AvailableStock = newAvailableStock;
        this.getChartByTitle("Stock Count")?.render();
      }
    }

    // ✅ IFA Tablet And Syrup Pie Chart  ✅
    // debugger
    this.AnemiaMuktaBharatTypesList = data.AnemiaMuktaBharatTypesResponse;

    if (
      this.AnemiaMuktaBharatTypesList.length ==
      this.AnemiaMuktaBharatTypesEnumList.length - 1
    ) {
      let IFATabletData = this.AnemiaMuktaBharatTypesList[0];
      let IFASyrupData = this.AnemiaMuktaBharatTypesList[1];
      if (
        IFATabletData.AnemiaMuktaBharatType ==
        this.AnemiaMuktaBharatTypesEnum.IFA_Tablet_Red
      ) {
        const newIFATablete = [
          {
            Name: "Received",
            Value: IFATabletData.ReceivedStock,
          },
          {
            Name: "Consumed",
            Value: IFATabletData.DistributedStock,
          },
          {
            Name: "Remaining",
            Value: IFATabletData.RemainingStock,
          },
        ];
        if (
          !this.previousData ||
          !this.isEqual(this.previousData.IFATablet, newIFATablete)
        ) {
          this.IFATablet = newIFATablete;
          this.getChartByTitle(
            IFATabletData.AnemiaMuktaBharatTypeName,
          )?.render();
        }
      }

      if (
        IFASyrupData.AnemiaMuktaBharatType ==
        this.AnemiaMuktaBharatTypesEnum.IFA_Syrup
      ) {
        const newIFASyrup = [
          {
            Name: "Received",
            Value: IFASyrupData.ReceivedStock,
          },
          {
            Name: "Consumed",
            Value: IFASyrupData.DistributedStock,
          },
          {
            Name: "Remaining",
            Value: IFASyrupData.RemainingStock,
          },
        ];
        if (
          !this.previousData ||
          !this.isEqual(this.previousData.IFASyrup, newIFASyrup)
        ) {
          this.IFASyrup = newIFASyrup;
          this.getChartByTitle(
            IFASyrupData.AnemiaMuktaBharatTypeName,
          )?.render();
        }
      }
    }

    // ✅ --- Distributed Stock Bar Chart ---
    // const stock = data;

    // let Name = "";
    // if (this.ReportFilterType == ReportFilterTypes.Yearly) {
    //   Name = "Yearly";
    // } else if (this.Month > 0) {
    //   const Month = this.MonthList.find((m) => m.Ref == this.Month);
    //   if (Month) {
    //     Name = Month.Name;
    //   }
    // }
    const stock = data.StockBuckets;
    const newDistributedStock: DistributedStockChartData[] = [
      {
        Name: "",
        SanitaryPads: 0,
        Condoms: 0,
        MalaN: 0,
        ECPills: 0,
        Chhaya: 0,
      },
    ];

    const typeMap: any = {
      [ContraceptivePillsTypes.None]: "SanitaryPads",
      [ContraceptivePillsTypes.Condom]: "Condoms",
      [ContraceptivePillsTypes.Mala_N]: "MalaN",
      [ContraceptivePillsTypes.ECPills]: "ECPills",
      [ContraceptivePillsTypes.Chhaya]: "Chhaya",
    };

    stock.forEach((e: StockBuckets) => {
      const key = typeMap[e.ContraceptivePillType];

      if (key) {
        (newDistributedStock[0] as any)[key] = e.DistributedStock ?? 0;
      }
    });

    if (
      !this.previousData ||
      !this.isEqual(this.previousData.DistributedStockData, newDistributedStock)
    ) {
      this.DistributedStockData = newDistributedStock;

      // ✅ Series / legend (display names only)
      this.DistributedStockList = [
        { p: { Name: "SanitaryPads", DisplayName: "Sanitary Pads" } },
        { p: { Name: "Condoms", DisplayName: "Condoms" } },
        { p: { Name: "MalaN", DisplayName: "Mala N" } },
        { p: { Name: "ECPills", DisplayName: "EC Pills" } },
        { p: { Name: "Chhaya", DisplayName: "Chhaya" } },
      ];
      this.resetChartZoom(this.distributedStockChart); // ✅ Reset zoom
    }

    // --- Store snapshot ---
    this.previousData = {
      ...data,
      MonthlyIncentiveTrend: this.MonthlyIncentiveTrend,
      TrainingCompletion: this.TrainingCompletion,
      performancephcdata: this.performancephcdata,
      AvailableStock: this.AvailableStock,
      IFATablet: this.IFATablet,
      IFASyrup: this.IFASyrup,
      DistributedStockData: this.DistributedStockData,
    };
    this.previousData = JSON.parse(JSON.stringify(data));
  };
    // Dashboard Fetch Fun End here

    customizeLabel = (arg: any) => {
  return `${arg.value}`;
};

  customizePieLabel = (arg: any) => {
    return `${arg.argumentText}: ${arg.valueText}`;
  };
  isTrainingDetailsEmpty(): boolean {
    return (
      !this.TrainingCompletion ||
      this.TrainingCompletion.length === 0 ||
      this.TrainingCompletion.every((name: any) => {
        // check if all Data values are zero
        return Object.keys(name)
          .filter((key) => key !== "PHCName")
          .every((Data) => name[Data] === 0);
      })
    );
  }

  isPerformanceDetailsEmpty(): boolean {
    return (
      !this.performancephcdata ||
      this.performancephcdata.length === 0 ||
      this.performancephcdata.every((month: any) => {
        // check if all Data values are zero
        return Object.keys(month)
          .filter((key) => key !== "PHCName")
          .every((Data) => month[Data] === 0);
      })
    );
  }

  isIncentiveBucketEmpty(): boolean {
    return (
      !this.monthlyincentiveofashadata ||
      this.monthlyincentiveofashadata.length === 0 ||
      this.monthlyincentiveofashadata.every((name: any) => {
        // check if all Data values are zero
        return Object.keys(name)
          .filter((key) => key !== "Name")
          .every((Data) => name[Data] === 0);
      })
    );
  }

  isDistributedStockDataEmpty(): boolean {
    return (
      !this.DistributedStockData ||
      this.DistributedStockData.length === 0 ||
      this.DistributedStockData.every((name: any) => {
        // check if all Data values are zero
        return Object.keys(name)
          .filter((key) => key !== "Name")
          .every((Data) => name[Data] === 0);
      })
    );
  }

  isIFATabletDataEmpty(): boolean {
    return (
      !this.IFATablet ||
      this.IFATablet.length === 0 ||
      this.IFATablet.every((name: any) => {
        // check if all Data values are zero
        return Object.keys(name)
          .filter((key) => key !== "Name")
          .every((Data) => name[Data] === 0);
      })
    );
  }
  isIFASyrupDataEmpty(): boolean {
    return (
      !this.IFASyrup ||
      this.IFASyrup.length === 0 ||
      this.IFASyrup.every((name: any) => {
        // check if all Data values are zero
        return Object.keys(name)
          .filter((key) => key !== "Name")
          .every((Data) => name[Data] === 0);
      })
    );
  }
  isAvailableStockDataEmpty(): boolean {
    return (
      !this.AvailableStock ||
      this.AvailableStock.length === 0 ||
      this.AvailableStock.every((name: any) => {
        // check if all Data values are zero
        return Object.keys(name)
          .filter((key) => key !== "Name")
          .every((Data) => name[Data] === 0);
      })
    );
  }

  // Helper to get PieChart by title
  getChartByTitle(title: string): any {
    return this.pieCharts.find(
      (chart) => chart.instance.option("title.text") === title,
    )?.instance;
  }

  // Cards Counter Animation Function //
  animateCounter(
    id: string,
    end: number,
    duration: number = 1500,
    isCurrency: boolean = false,
    suffix: string = "", // optional, for % or other symbols
  ) {
    const obj = document.getElementById(id);
    if (!obj) return;

    // Clear previous timer if exists
    if (this.counterTimers[id]) {
      clearInterval(this.counterTimers[id]);
    }

    const start = parseInt(obj.innerText.replace(/[^0-9]/g, "")) || 0;
    const range = end - start;
    if (range === 0) {
      obj.innerText = isCurrency
        ? `₹${end.toLocaleString("en-IN")}`
        : `${end.toLocaleString("en-IN")}${suffix}`;
      return;
    }

    const fps = 60;
    const interval = 1000 / fps;
    const steps = Math.ceil(duration / interval);
    let currentStep = 0;

    this.counterTimers[id] = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;
      const easedProgress = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      const currentValue = start + range * easedProgress;

      obj.innerText = isCurrency
        ? `₹${Math.floor(currentValue).toLocaleString("en-IN")}`
        : `${Math.floor(currentValue).toLocaleString("en-IN")}${suffix}`;

      if (currentStep >= steps) {
        clearInterval(this.counterTimers[id]);
        delete this.counterTimers[id];
        obj.innerText = isCurrency
          ? `₹${end.toLocaleString("en-IN")}`
          : `${end.toLocaleString("en-IN")}${suffix}`;
      }
    }, interval);
  }

  customizeTooltip(arg: any) {
    const percent = (arg.percent * 100).toFixed(1);
    return {
      text: `${arg.argumentText}: ${arg.valueText} (${percent}%)`,
    };
  }

  // Monthly Incentive Trend Line Chart to show month and count
  customizeMonthlyIncentiveTrend = (info: any) => {
    const formattedValue = Number(info.value).toLocaleString("en-IN");
    return {
      html: `<b>${info.argument}</b><br/>Incentive: <span style="color:black">₹${formattedValue}</span>`,
    };
  };

  formatIndianNumber(value: number): string {
    if (value === null || value === undefined) return "";
    return value.toLocaleString("en-IN", { maximumFractionDigits: 2 });
  }

  // Click to show or hide bar

  onLegendClick(e: any) {
    const series = e.component
      .getAllSeries()
      .find((s: any) => s.name === e.target.name);
    if (series) {
      if (series.isVisible()) {
        series.hide();
      } else {
        series.show();
      }
    }
  }

  // MAintain Dropdown Filter State Calls

  onRoleChanged = async (e: any) => {
    const newValue = e.value;

    if (!newValue || newValue === 0) {
      e.component.option("Not Select the Role");
      return;
    }
    this.filterStorage.setFilterState({
      IncentiveRole: this.DashboardFilterService.IncentiveRole,
    });
    // this.DashboardFilterService.IncentiveRole = newValue;
    await this.FormulateDashboardList();
  };

  // According to Role Selection We navigate to Report //
  onCardClick(cardType: string) {
    if (
      !this.DashboardFilterService.IncentiveRole ||
      this.DashboardFilterService.IncentiveRole === 0
    ) {
      this.uiUtils.showErrorMessage("Error", "Please select role first");
      return;
    }

    switch (this.DashboardFilterService.IncentiveRole) {
      case IncentiveRoles.AF:
        this.router.navigate(["Dashboard_AF_Central_State_Incentive"]);
        break;

      case IncentiveRoles.Asha:
        this.router.navigate(["Dashboard_Asha_Central_State_Incentive"]);
        break;

      // case IncentiveRoles.AshaAndAF:
      //   this.router.navigate(["Asha-Af-Employee-State-Incentive-Report"]);
      //   break;

      default:
        break;
    }
  }

  onHalfYearChanged = async (e: any) => {
    const newValue = e.value;

    if (!newValue || newValue === 0) {
      e.component.option("Not Selected Half Year Type");
      return;
    }
    this.DashboardFilterService.HalfYearType = newValue;

    this.filterStorage.setFilterState({
      HalfYearType: this.DashboardFilterService.HalfYearType,
    });

    await this.FormulateDashboardList();
  };

  onQuarterChanged = async (e: any) => {
    const newValue = e.value;

    if (!newValue || newValue === 0) {
      e.component.option("Not Selected Quarterly Year Type");
      return;
    }
    this.DashboardFilterService.QuarterlyYearType = newValue;

    this.filterStorage.setFilterState({
      QuarterlyYearType: this.DashboardFilterService.QuarterlyYearType,
    });

    await this.FormulateDashboardList();
  };

  onMonthChanged = async (e: any) => {
    const newValue = e.value;

    if (!newValue || newValue === 0) {
      e.component.option("Not Select Month");
      return;
    }
    this.DashboardFilterService.Month = newValue;

    this.filterStorage.setFilterState({
      Month: this.DashboardFilterService.Month,
    });

    await this.FormulateDashboardList();
  };

  onStateChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOZoneLevel();

    // this.FilterStateStorage.setFilterState({
    //   StateRefs: this.DashboardFilterService.StateRefs,
    // });
  };

  onZoneChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTODistrictLevel();

    // this.FilterStateStorage.setFilterState({
    //   ZoneRefs: this.DashboardFilterService.ZoneRefs,
    // });
  };

  onDistrictChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOBlockLevel();

    // this.FilterStateStorage.setFilterState({
    //   DistrictRefs: this.DashboardFilterService.DistrictRefs,
    // });
  };

  onBlockChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOBCMPostLevel();

    // this.FilterStateStorage.setFilterState({
    //   BlockRefs: this.DashboardFilterService.BlockRefs,
    // });
  };

  onBCMPostChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOPHCLevel();

    // this.FilterStateStorage.setFilterState({
    //   bcm_post_ids: this.DashboardFilterService.bcm_post_ids,
    // });
  };

  onPHCChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOAFPostLevel();

    // this.FilterStateStorage.setFilterState({
    //   phc_ids: this.DashboardFilterService.phc_ids,
    // });
  };

  onAFPostChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOSCLevel();

    // this.FilterStateStorage.setFilterState({
    //   AFRefs: this.DashboardFilterService.AFRefs,
    // });
  };

  onSCChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOVillageLevel();

    // this.FilterStateStorage.setFilterState({
    //   SCRefs: this.DashboardFilterService.SCRefs,
    // });
  };

  onVillageChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // Load next hierarchy
    await this.DashboardFilterService.LoadFilterDataUPTOAshaLevel();

    // this.FilterStateStorage.setFilterState({
    //   VillageRefs: this.DashboardFilterService.VillageRefs,
    // });
  };

  onAshaChanged = async (e: any) => {
    // ⭐ Prevent infinite loop
    if (!e.event) return;

    // this.FilterStateStorage.setFilterState({
    //   AshaRefs: this.DashboardFilterService.AshaRefs,
    // });
  };

  onStateandCentralIncentiveCardClick(cardType: string) {
    if (
      !this.DashboardFilterService.IncentiveRole ||
      this.DashboardFilterService.IncentiveRole === 0
    ) {
      this.uiUtils.showErrorMessage("Error", "Please select role first");
      return;
    }

    // ✅ Set CardType for title
    this.DashboardFilterService.CardType = cardType;

    // ✅ Set IncentiveType based on card clicked
    switch (cardType) {
      case "Sanctioned":
        this.DashboardFilterService.StateIncentiveType =
          StateIncentiveTypes.Sanction; // 100
        break;
      case "TotalGiven":
        this.DashboardFilterService.StateIncentiveType =
          StateIncentiveTypes.Given; // 200
        break;
      case "Pending":
        this.DashboardFilterService.StateIncentiveType =
          StateIncentiveTypes.Remaining; // 300
        break;
      default:
        this.DashboardFilterService.StateIncentiveType =
          StateIncentiveTypes.None; // 0
        break;
    }

    // ✅ Navigate based on role
    switch (this.DashboardFilterService.IncentiveRole) {
      case IncentiveRoles.AF:
        this.router.navigate(["Dashboard_AF_Central_State_Incentive"]);
        break;
      case IncentiveRoles.Asha:
        this.router.navigate(["Dashboard_Asha_Central_State_Incentive"]);
        break;
      default:
        break;
    }
  }

  // Static Values //

  LactatingMotherType: any[] = [];

  setPNCStaticData() {
    const isAsha = this.LoginEmployeeRole === this.Roles.Asha;

    if (isAsha) {
      // 👇 Smaller numbers for ASHA
      this.LactatingMotherType = [
        { Name: "Total PNC Registered", Value: 20 },
        { Name: "PNC within 48 Hours", Value: 12 },
        { Name: "PNC within 7 Days", Value: 15 },
        { Name: "Exclusive Breastfeeding", Value: 10 },
      ];
    } else {
      // 👇 Bigger numbers for DCM / BCM / others
      this.LactatingMotherType = [
        { Name: "Total PNC Registered", Value: 420 },
        { Name: "PNC within 48 Hours", Value: 180 },
        { Name: "PNC within 7 Days", Value: 125 },
        { Name: "Exclusive Breastfeeding", Value: 260 },
      ];
    }
  }

//   setPNCStaticData() {
//   const isAsha = this.LoginEmployeeRole === 700;

//   const baseData = isAsha
//     ? [
//         { key: 'TOTAL_PNC', Value: 20 },
//         { key: 'PNC_48H', Value: 12 },
//         { key: 'PNC_7D', Value: 15 },
//         { key: 'EXCLUSIVE_BF', Value: 10 },
//       ]
//     : [
//         { key: 'TOTAL_PNC', Value: 420 },
//         { key: 'PNC_48H', Value: 180 },
//         { key: 'PNC_7D', Value: 125 },
//         { key: 'EXCLUSIVE_BF', Value: 260 },
//       ];

//   this.LactatingMotherType = baseData.map(item => ({
//     Name: this.getPNCLabel(item.key),
//     Value: item.Value
//   }));
// }
// getPNCLabel(key: string): string {
//   const isMarathi = this.langService.currentLang === 'mr';

//   const labels: any = {
//     TOTAL_PNC: {
//       en: 'Total PNC Registered',
//       mr: 'एकूण PNC नोंदणी'
//     },
//     PNC_48H: {
//       en: 'PNC within 48 Hours',
//       mr: '४८ तासांत PNC'
//     },
//     PNC_7D: {
//       en: 'PNC within 7 Days',
//       mr: '७ दिवसांत PNC'
//     },
//     EXCLUSIVE_BF: {
//       en: 'Exclusive Breastfeeding',
//       mr: 'पूर्ण स्तनपान'
//     }
//   };

//   return isMarathi ? labels[key].mr : labels[key].en;
// }


  LifestyleDisease: any[] = [
    { Name: "Cancer", Value: 25 },
    { Name: "Stroke", Value: 15 },
    { Name: "Hypertension", Value: 30 },
    { Name: "Asthma", Value: 20 },
    { Name: "Fatigue", Value: 15 },
  ];

  TBPatientFunnel = [
    { stage: "Total TB Cases", value: 1000 },
    { stage: "Treatment Completed", value: 550 },
    { stage: "Active Treatment", value: 380 },
    { stage: "Defaulters", value: 70 },
  ];

  formatFunnelLabel = (arg: any) => {
    return `${arg.value}`;
  };

  childData = [
    { name: "Total Children", value: 1200 },
    { name: "Fully Immunized", value: 850 },
    { name: "Partially Immunized", value: 300 },
    { name: "Due for Immunization", value: 150 },
  ];
  formatChartLabel = (arg: any) => {
    return arg.value.toLocaleString("en-IN");
  };

  // ── i18n Display Helpers ──────────────────────────────────────────────────
    getTranslatedName = (item: any): string =>
    item ? this.translate.instant(item.Name) : "";



  // bi-lingual

  getRiskSeriesName(): string {
  return this.langService.currentLang === 'mr'
    ? 'जोखीम संख्या'   // Marathi
    : 'Risk Count';    // English
}

customizeTooltipFamily(arg: any) {
  return {
    text: `${arg.argumentText}: ${arg.value}`
  };
}



}
